import React, {Component} from 'react';
import {Field, reduxForm} from "redux-form";
import {connect} from "react-redux";
import * as actions from "../../actions/index";
import {isChecked, priceList} from "../../util/broadcaster/profile_util";
import {isEmpty, removeWordFromList, required, vuepayAlert} from "../../util/utility";
import {getData, LOGIN} from "../../util/storage";
import {renderField, renderTextAreaField} from "../../util/account_management";
import {checkIfCreateBroadcast} from "../../util/broadcast";
import {updateJWTToken} from "../../util/broadcast/create";
import {changeBroadcastOnFirestore} from "../../util/firebase/firestore";
import information from "../../assets/images/information.svg";
import {Button} from "reactstrap";
import assets from "../../util/assets";

class ChangeBroadcast extends Component {

    constructor() {
        super();

        this.state = {
            count: 0,
            formData: null,
            broadcast_type: '',
            broadcast_session_type: 'free',
            allow_one_to_one:null,
            optionTemplate: priceList().map(v => (<option key={v} value={v}>{parseFloat(v / 100).toFixed(2)}</option>))
        }

        //all the functions used in this component should be listed here for better documentation
        this.onSubmit = this.onSubmit.bind(this);
        this.toggle = this.toggle.bind(this);
        this.textAreaChange = this.textAreaChange.bind(this);
    }

    componentDidMount() {

        /**
         * update the status of the button along with the text size for session description
         */
        this.setState({
            count: this.props.initialValues.session_description.length,
            broadcast_type: this.props.initialValues.broadcast_type,
            broadcast_session_type: this.props.initialValues.one_to_one_session_price >0 ? "paid" : "free"
        })
    }

    UNSAFE_componentWillReceiveProps(nextProps) {

        //console.log(nextProps);

        if (checkIfCreateBroadcast(nextProps)) {

            if (nextProps.broadcast.payload.status_code === 201) {

                console.log("took this")
                const payload = nextProps.broadcast.payload;
                //if the status_code received from the server is 201 means the broadcast was created successfully
                nextProps.resetCreateBroadcast();

                updateJWTToken(payload, () => {
                    /**
                     * @business_rule
                     * the token is updated in the session now we have to perform following actions
                     * 1. update firestore <base_path>/previous_broadcast_id/change_broadcast/new_broadcast_id
                     * {
                            "broadcast_type": "<broadcast_type>",
                            "group_session_price": "<group_session_price>",
                            "one_to_one_session_allow": "<one_to_one_session_allow>",
                            "one_to_one_session_price": "<one_to_one_session_price>",
                            "session_description": "<session_description>",
                            "session_title": "<session_title>"
                     *  }
                     *  2. close tokbox session
                     *  3. update the url
                     *           const broadcastID = getEncryptedIdForBroadcaster(this.state.broadcast_id);
                     this.props.history.push(`/broadcaster/start/broadcast?session_id=${this.state.session_id}&broadcast_id=${broadcastID}&token=${this.state.token}`, {
                                    session_id: this.state.session_id,
                                    broadcast_id: this.state.broadcast_id,
                                    token: this.state.token
                                })
                     */
                    changeBroadcastOnFirestore(
                        this.props.initialValues.id.toString(),
                        nextProps.broadcast.payload.data.id.toString(),
                        {
                            "broadcast_type": this.state.formData.broadcast_type,
                            "group_session_price": this.state.formData.group_session_price,
                            "one_to_one_session_allow": this.state.formData.one_to_one_session_allow,
                            "one_to_one_session_price": this.state.formData.one_to_one_session_price,
                            "session_description": this.state.formData.session_description,
                            "session_title": this.state.formData.session_title
                        },
                        () => {
                            this.props.disconnectFromTokBoxAndChangeBroadcast(nextProps.broadcast.payload.data)
                        }
                    )
                });

                vuepayAlert("success", "Broadcast data changed successfully");

            } else if (nextProps.broadcast.payload.status_code === 200) {

                //if the status_code received from the server is 200 means the broadcast was updated successfully

                const message = nextProps.broadcast.payload.message;
                nextProps.resetUpdateBroadcast();
                vuepayAlert("success", message);

                /**
                 * @Webservice GET Broadcast detail API
                 */
                getData(LOGIN)
                    .then((data) => {
                        if (!isEmpty(data)) {
                            this.props.getBroadcastDetail(data.token, data.api_token, this.props.initialValues.id)
                        }
                    })

            } else {
                //if the status_code received from the server is NOT 200 means there has been some error occurred
                nextProps.resetCreateBroadcast();
                nextProps.resetUpdateBroadcast();
                vuepayAlert("error", nextProps.broadcast.payload.message);
            }
        }

    }

    onSubmit(values) {

        const formData = {
            session_title: values.session_title,
            session_description: values.session_description,
            broadcast_type: this.state.broadcast_type,
            one_to_one_session_allow: isChecked("one_to_one_session_allow"),
            one_to_one_session_price: parseInt(document.getElementsByName("one_to_one_session_price")[0].value),
            group_session_price: (this.state.broadcast_type === "free") ? 0 : parseInt(document.getElementsByName("group_session_price")[0].value),
            is_chat_allowed: true,
            is_hls: false,
            device: this.props.device,
            broadcast_id: this.props.initialValues.id.toString()
        };

        this.setState({
            formData: formData
        });

        console.log(formData);
        console.log(this.props.initialValues);

        //dispatch an action to POST the channel picture/image to the Webservice
        getData(LOGIN)
            .then((data) => {
                if (!isEmpty(data)) {
                    //this.props.createBroadcast(data.token, data.api_token, formData);
                    /**
                     * @business_rule
                     * if the user has changed only session title and session description then call updateBroadcast
                     * else call createBroadcast
                     */
                    if (this.props.initialValues.broadcast_type !== formData.broadcast_type ||
                        this.props.initialValues.one_to_one_session_allow !== formData.one_to_one_session_allow ||
                        this.props.initialValues.one_to_one_session_price !== formData.one_to_one_session_price ||
                        this.props.initialValues.group_session_price !== formData.group_session_price) {

                        console.log("inside if")

                        //create broadcast
                        this.props.createBroadcast(data.token, data.api_token, formData);

                    } else if (this.props.initialValues.session_title !== formData.session_title ||
                        this.props.initialValues.session_description !== formData.session_description) {
                        /**
                         * @Webservice PUT Update Broadcast API
                         */

                        console.log("inside else")

                        this.props.updateBroadcast(data.token, data.api_token, this.props.initialValues.id, {
                            session_title: values.session_title,
                            session_description: values.session_description,
                            device: this.props.device
                        });
                    } else {
                        vuepayAlert("error", "We cannot process your request as nothing has been changed");
                    }
                }
            })
    }

    toggle(_type) {
        this.setState({
            broadcast_type: _type
        }, () => {

            const index = (_type === "free") ? 0 : 1,
                target = document.getElementsByClassName("broadcast_type")[index],
                oppositeIndex = (_type === "free") ? 1 : 0,
                oppositeTarget = document.getElementsByClassName("broadcast_type")[oppositeIndex];

            if (target.classList.contains("active")) {
                target.classList.remove("active")
            } else {
                oppositeTarget.classList.remove("active")
                target.classList.add("active")
            }
        })
    }

    handleChangeBroadcastType = (event, newValue, previousValue, name) => {
        this.setState({
            broadcast_type: newValue
        });
    }

    handleChangeBroadcastSessionType = (event, newValue, previousValue, name) => {
        this.setState({
            broadcast_session_type: newValue
        })
    }

    handleOnoToOneSession = (event, newValue, previousValue, name) => {
        this.setState({
            allow_one_to_one: newValue
        })
    }

    handleOnBlur = (event, newValue, previousValue, name) => {
        setTimeout(() => {
            const newData = removeWordFromList(this.props.account_management.userDetails.broadcaster[0].id, this.props.profanity, newValue, true, false);
            this.props.dispatch(this.props.change( name, newData));
        }, 0);
    }


    /**
     * @function listener for text area change we use this to maintain the count of the characters the user has typed
     * @param e
     */
    textAreaChange(event, newValue, previousValue, name) {
        setTimeout(() => {
            const newData = removeWordFromList(this.props.account_management.userDetails.broadcaster[0].id, this.props.profanity, newValue, true, false);
            this.props.dispatch(this.props.change( name, newData));
            this.setState({
                count: newData.length,
            });
        }, 0);
    }

    render() {

        const { handleSubmit } = this.props;

        return (
            <div className="wrapper-content change-broadcast">
                <div className="wrapper" style={{marginTop: 8, marginBottom: 8}}>
                    <form onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                        <dl className="row no-margin padding-16" style={{textAlign: 'left'}}>

                            <dt className="col-sm-6 no-margin no-padding">Broadcast Type</dt>
                            <dd className="col-sm-6 no-margin no-padding">
                                <div className="form-group">
                                    <label className="broadcastType">
                                        <Field
                                            name="broadcast_type"
                                            component="input"
                                            type="radio"
                                            value="free"
                                            onChange={this.handleChangeBroadcastType}
                                        />{" "}
                                        Free
                                    </label>
                                    <label className="broadcastType">
                                        <Field
                                            name="broadcast_type"
                                            component="input"
                                            type="radio"
                                            value="paid"
                                            onChange={this.handleChangeBroadcastType}
                                        />{" "}
                                        Paid
                                    </label>
                                </div>
                            </dd>

                            <dt className="col-sm-6 no-margin no-padding">Allow 1 on 1 sessions</dt>
                            <dd className="col-sm-6 no-margin no-padding">
                                <div className="form-group">
                                    <label className="checkbox">
                                        <Field
                                            name="one_to_one_session_allow"
                                            component="input"
                                            type="checkbox"
                                            onChange={this.handleOnoToOneSession}
                                        />
                                        <span className="checkmark"></span>
                                    </label>
                                </div>
                            </dd>


                            <dt className={isChecked("one_to_one_session_allow") ? "col-sm-6 no-margin no-padding thing-enter" : "col-sm-6 no-margin no-padding thing-leave"}>1
                                on 1 session type
                            </dt>
                            <dd className={isChecked("one_to_one_session_allow") ? "col-sm-6 no-margin no-padding thing-enter" : "col-sm-6 no-margin no-padding thing-leave"}>
                                <div className="form-group">
                                    <label className="ageGroup">
                                        <Field name="broadcast_session_type"
                                               component="input"
                                               type="radio"
                                               value="free"
                                               onChange={this.handleChangeBroadcastSessionType}
                                        /> Free</label>
                                    <label className="ageGroup">
                                        <Field name="broadcast_session_type"
                                               component="input"
                                               type="radio"
                                               value="paid"
                                               onChange={this.handleChangeBroadcastSessionType}
                                        /> Paid</label>
                                </div>
                            </dd>

                            <dt className={isChecked("one_to_one_session_allow") && this.state.broadcast_session_type !== "free" ? "col-sm-6 no-margin no-padding thing-enter" : "col-sm-6 no-margin no-padding thing-leave"}>
                                Set 1 on 1 price
                            </dt>
                            <dd className={isChecked("one_to_one_session_allow") && this.state.broadcast_session_type !== "free" ? "col-sm-6 no-margin no-padding thing-enter" : "col-sm-6 no-margin no-padding thing-leave"}>
                                <div className="form-group">
                                    <Field className="custom-select"
                                           name="one_to_one_session_price"
                                           component="select">
                                        {this.state.broadcast_session_type === "free" ?
                                            <option key={0.00} value={0.00}>0.00</option> : this.state.optionTemplate}
                                    </Field>
                                    <span>£/min</span>
                                </div>
                            </dd>

                            <dt className={this.state.broadcast_type === "paid" ? "col-sm-6 no-margin no-padding thing-enter" : "col-sm-6 no-margin no-padding thing-leave"}>
                                Set group price
                            </dt>
                            <dd className={this.state.broadcast_type === "paid" ? "col-sm-6 no-margin no-padding thing-enter" : "col-sm-6 no-margin no-padding thing-leave"}>
                                <div className="form-group">
                                    <Field className="custom-select" name="group_session_price" component="select">
                                        {this.state.optionTemplate}
                                    </Field>
                                    <span>£/min</span>
                                </div>
                            </dd>

                            <dt className={"col-sm-6 no-margin no-padding thing-enter"}>
                                Age rating <a
                                href="https://www.bbfc.co.uk/about-classification/classification-guidelines"
                                target="_blank"><img alt={"close-icon"} src={information}/></a>
                            </dt>
                            <dd className={"col-sm-6 no-margin no-padding thing-enter"}>
                                <div className="form-group">
                                    <label className="ageGroup">
                                        <Field name="age_group"
                                               component="input"
                                               type="radio"
                                               value="less_than_12"/>
                                        Under 12
                                    </label>
                                    <label className="ageGroup">
                                        <Field name="age_group"
                                               component="input"
                                               type="radio"
                                               value="more_than_12"/> 12+
                                    </label>
                                    <label className="ageGroup">
                                        <Field name="age_group"
                                               component="input"
                                               type="radio"
                                               value="more_than_15"/>
                                        15+
                                    </label>
                                    <label className="ageGroup">
                                        <Field name="age_group"
                                               component="input"
                                               type="radio"
                                               value="18"/> 18
                                    </label>
                                </div>
                            </dd>

                            <Field
                                name="broadcast_type"
                                component="input"
                                type="hidden"
                                value={this.state.broadcast_type}
                            />


                            <dt className="col-sm-6 no-margin no-padding">Session title</dt>
                            <dd className="col-sm-6 no-margin no-padding">
                                <div className="form-group">
                                    <Field
                                        label=""
                                        name="session_title"
                                        type="text"
                                        height={"32px"}
                                        onBlur={this.handleOnBlur}
                                        onChange={this.handleOnBlur}
                                        username={null}
                                        validate={[required]}
                                        component={renderField}
                                    />
                                </div>
                            </dd>

                            <dt className="col-sm-6 no-margin no-padding">Session description</dt>
                            <dd className="col-sm-6 no-margin no-padding">
                                <div className="form-group">
                                    <Field
                                        label=""
                                        name="session_description"
                                        maxLength="280"
                                        minLength="1"
                                        height={"153px"}
                                        count={this.state.count}
                                        validate={[required]}
                                        onBlur={this.textAreaChange}
                                        component={renderTextAreaField}
                                        onChange={this.textAreaChange}
                                    />
                                </div>
                            </dd>

                            <dt className="col-sm-12 no-margin no-padding change-broadcast-button-container" style={{marginTop:120}}>
                                {
                                    this.props.broadcast.isFetching ? (
                                        <Button
                                            color="primary"
                                            className="request-button"
                                        >
                                            <img
                                                src={assets.loading_white}
                                                alt={"Loading"}
                                                width={26}
                                                height={26}
                                            />
                                        </Button>
                                    ) : (
                                        <Button
                                            color="primary"
                                            className="request-button"
                                        >
                                            Change Broadcast
                                        </Button>
                                    )
                                }
                            </dt>

                        </dl>
                    </form>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {

    return {
        broadcast: state.broadcast,
        device: state.device.payload,
        account_management: state.account_management,
        profanity: state.profanity.words
    };
}

// Decorate with reduxForm(). It will read the initialValues prop provided by connect()
ChangeBroadcast = reduxForm({
    form: 'ChangeBroadcastForm', // a unique identifier for this form
    enableReinitialize: true
})(ChangeBroadcast);

// You have to connect() to any reducers that you wish to connect to yourself
ChangeBroadcast = connect(
    mapStateToProps,
    actions, // bind account loading action creator
)(ChangeBroadcast);

export default ChangeBroadcast;